import React, { Fragment } from 'react';
import Header from './Header';
import Footer from './Footer';


const TermsConditions = () => {
    return (
        <Fragment>
            <Header />
            <div className="custom-banner-1">
                <div className="container">
                    <div className="custom-banner-content">
                        <div className="left-content">
                            <h1>
                                <span className="g-c-b">Terms &</span> Conditions
                            </h1>
                        </div>
                        <div className="right-content">
                            <hr
                                className="orange-line"
                                style={{ height: '5px', width: '50px', background: '#00a798', opacity: '1' }}
                            />
                            <p>
                                These Terms and Conditions govern your use of our website design services at Kumbhaatech Solutions. By engaging with us, you agree to these terms.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className='container'>

                    <div className="privacy-content">
                        <h2>1. Acceptance of Terms</h2>
                        <p>
                            By engaging Kumbhaatech Solutions ("Company," "we," "us," or "our") for website design services, you ("Client," "you," or "your") agree to these Terms and Conditions ("Terms").
                        </p>

                        <h2>2. Scope of Services</h2>
                        <p>
                            Services provided are defined in the Project Agreement. Additional services may incur extra charges.
                        </p>

                        <h2>3. Payment Terms</h2>
                        <ul>
                            <li><strong>Deposit:</strong> A non-refundable deposit is required to begin work.</li>
                            <li><strong>Milestone Payments:</strong> Payments are made as follows:

                                <ul>
                                    <br />
                                    <li>30% upon initial design completion</li>
                                    <li>30% upon development completion</li>
                                    <li>40% upon final delivery</li>
                                </ul>
                            </li>
                            <li><strong>Final Payment:</strong> Due before website delivery or launch.</li>
                            <li><strong>Late Payments:</strong> Incur a 5% fee after 15 days.</li>

                            <li><strong>Payment Methods:</strong> Accepted via [Bank Transfer, Credit Card, PayPal, etc.].</li>
                        </ul>

                        <h2>4. Revisions and Changes</h2>
                        <ul>
                            <li>Includes 7 rounds of revisions.</li>
                            <li>Scope changes must be written and may alter cost/timeline.</li>
                        </ul>

                        <h2>5. Client Responsibilities</h2>
                        <ul>
                            <li>Client must provide all content and feedback promptly.</li>
                            <li>Client-caused delays may impact timeline and cost.</li>
                        </ul>

                        <h2>6. Intellectual Property</h2>
                        <ul>
                            <li>Final design belongs to Client upon full payment.</li>
                            <li>We may showcase work in our portfolio unless otherwise agreed.</li>
                        </ul>

                        <h2>7. Cancellation and Termination</h2>
                        <ul>
                            <li>Client may cancel at any time with written notice.</li>
                            <li>Client must pay for work completed up to cancellation date.</li>
                            <li>We may terminate for non-compliance or non-payment.</li>
                        </ul>

                        <h2>8. Warranty and Support</h2>
                        <ul>
                            <li>We provide a 30-day bug-fix warranty post-launch.</li>
                            <li>Ongoing support available under separate agreement.</li>
                        </ul>

                        <h2>9. Limitation of Liability</h2>
                        <ul>
                            <li>No liability for indirect or consequential damages.</li>
                            <li>Our total liability is limited to project fees paid.</li>
                        </ul>

                        <h2>10. Confidentiality</h2>
                        <ul>
                            <li>Both parties agree to protect confidential information.</li>
                            <li>We won't share client data without consent.</li>
                        </ul>

                        <h2>11. Governing Law</h2>
                        <p>
                            These Terms are governed by the laws of India/Tamil Nadu, and disputes are resolved in the courts of Chennai, Tamil Nadu.
                        </p>


                        <h2>12. Amendments</h2>
                        <p>
                            We may update these Terms at any time. Clients will be notified of significant changes.
                        </p>

                        <h2>13. Acceptance</h2>
                        <p>
                            By proceeding, you acknowledge understanding and agreement to these Terms.
                        </p>

                        <hr />

                        <h2>Contact Information</h2>
                        <p>
                            Kumbhaatech Solutions<br />
                            Medavakkam<br />
                            <a href="mailto:support@kumbhaatech.com">support@kumbhaatech.com</a><br />
                            +91-7880002227
                        </p>
                    </div>
                </div></section>
            <Footer />
        </Fragment>
    );
};

export default TermsConditions;
